<div class="flex-horizontal section-title-container">
  <div class="section-heading">
    <div class="section-title">Manage your Services</div>
    <div class="dds-label greyed-out">
      Here you can view the services added to your project, update them and add new ones.
    </div>
  </div>
  <div>
    <dds-button
      [theme]="createServiceButtonOptions.theme"
      [kind]="createServiceButtonOptions.kind"
      [size]="createServiceButtonOptions.size"
      [width]="createServiceButtonOptions.width"
      [icon]="createServiceButtonOptions.icon"
      [isIconLeft]="createServiceButtonOptions.isIconLeft"
      [role]="createServiceButtonOptions.role"
      [isInverse]="createServiceButtonOptions.isInverse"
      [isColorBg]="createServiceButtonOptions.isColorBg"
      [isLoading]="createServiceButtonOptions.isLoading"
      [ariaLabel]="createServiceButtonOptions.ariaLabel"
      [customClass]="createServiceButtonOptions.customClass"
      (clicked)="createServiceClick()"
      >Create a new Service</dds-button
    >
  </div>
</div>

<div class="flex-horizontal dds-mb-3">
  <div>
    <div class="dds-label greyed-out">Service</div>
    <div>
      <dds-dropdown
        [theme]="dropdownOptions.theme"
        [kind]="dropdownOptions.kind"
        [size]="dropdownOptions.size"
        [label]="dropdownOptions.label"
        [width]="dropdownOptions.width"
        [isInverse]="dropdownOptions.isInverse"
        [isColorBg]="dropdownOptions.isColorBg"
        [disabled]="dropdownOptions.disabled"
        [customClass]="dropdownOptions.customClass"
        [isResponsive]="dropdownOptions.isResponsive"
        [stickerWidth]="dropdownOptions.stickerWidth"
        [stickerIsOutsideClick]="dropdownOptions.stickerIsOutsideClick"
        [stickerShift]="dropdownOptions.stickerShift"
        [stickerMaxHeight]="dropdownOptions.stickerMaxHeight"
        [stickerIsDisabled]="dropdownOptions.stickerIsDisabled"
        [stickerPosition]="dropdownOptions.stickerPosition"
        [stickerIndent]="dropdownOptions.stickerIndent"
        [stickerCustomClass]="dropdownOptions.stickerCustomClass"
        [stickerIsDynamic]="dropdownOptions.stickerIsDynamic"
        (itemSelected)="itemSelected($event)"
      >
        @for (item of dropdownItems; track item) {
        <dds-dropdown-item [value]="item.value" [counter]="item.counter" [disabled]="item.disabled">{{
          item.heading
        }}</dds-dropdown-item>
        }
      </dds-dropdown>
    </div>
  </div>
  @if (services && services.length > 0) {
  <div class="upload-button-container">
    <dds-button
      [theme]="editServiceButtonOptions.theme"
      [kind]="editServiceButtonOptions.kind"
      [size]="editServiceButtonOptions.size"
      [width]="editServiceButtonOptions.width"
      [icon]="editServiceButtonOptions.icon"
      [isIconLeft]="editServiceButtonOptions.isIconLeft"
      [role]="editServiceButtonOptions.role"
      [isInverse]="editServiceButtonOptions.isInverse"
      [isColorBg]="editServiceButtonOptions.isColorBg"
      [isLoading]="editServiceButtonOptions.isLoading"
      [ariaLabel]="editServiceButtonOptions.ariaLabel"
      [customClass]="editServiceButtonOptions.customClass"
      (clicked)="editServiceClick()"
      >Edit</dds-button
    >
  </div>
  }
</div>

@if (services && services.length > 0) {
<div class="service-identifier-container">
  <div class="service-identifier">
    <div class="service-identifier-title">Service Identifier</div>
    <div class="service-identifier-label">{{ serviceId }}</div>
  </div>
  <dds-button
    [theme]="copyButtonOptions.theme"
    [kind]="copyButtonOptions.kind"
    [size]="copyButtonOptions.size"
    [width]="copyButtonOptions.width"
    [icon]="copyButtonOptions.icon"
    [isIconLeft]="copyButtonOptions.isIconLeft"
    [role]="copyButtonOptions.role"
    [isInverse]="copyButtonOptions.isInverse"
    [isColorBg]="copyButtonOptions.isColorBg"
    [isLoading]="copyButtonOptions.isLoading"
    [ariaLabel]="copyButtonOptions.ariaLabel"
    [customClass]="copyButtonOptions.customClass"
    (clicked)="copyClick()"
  ></dds-button>
</div>

<div class="max-width-533">
  @if (currentService) {
  <p>{{ currentService.description }}</p>

  <p>
    This service is linked to the API specification
    <a (click)="viewApiSpecificatioClick()" class="dds-link">{{ currentService.specification }}</a>
  </p>
  }

  <p>
    You can use this service in your applications by replacing your regular API endpoint's base URL to
    <code>https://echo.dtcs.eu</code>, and adding an HTTP header to your requests with the key
    <code>x-session</code> and as value your service identifier and a session identifier, separated by an underscore
    <code>_</code>
  </p>
  <p>
    You can find the session identifier above. You are responsible for creation and management of the session
    identifier. Every time you use the same session identifier, all previous API calls are taken into account. In terms
    of Large Language Models, this determines your 'context'. We recommend you to use new, never before used session
    identifiers often, to ensure clean testing sessions and reliability of your service.
  </p>
</div>
} @else {
<div class="dds-mt-4">
  <p class="dds-label greyed-out">
    No services have been created for this project yet. Click "Create a new Service" to get started.
  </p>
</div>
}
